import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = cargando, null = no autenticado
  const [area, setAreaState] = useState(localStorage.getItem("ts_area") || "General");

  useEffect(() => {
    const token = localStorage.getItem("ts_token");
    if (!token) return setUser(null);
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ts_token", r.data.token);
    localStorage.setItem("ts_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ts_token");
    localStorage.removeItem("ts_user");
    setUser(null);
  }, []);

  const setArea = useCallback((a) => {
    localStorage.setItem("ts_area", a);
    setAreaState(a);
  }, []);

  return <AuthCtx.Provider value={{ user, login, logout, area, setArea }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
